"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var passwordValidator = (0, _validation.createValidator)({
  password: [_validation.required, (0, _validation.minLength)(8)],
  password2: [_validation.required, (0, _validation.matchPasswords)("password")]
});
exports.default = (0, _lruMemoize2.default)(10)(passwordValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Password/passwordValidator.js
 ** module id = 1226
 ** module chunks = 0
 **/